const PreviewApplication = () => import('../views/job-application/PreviewApplication.vue')
const JobApplicationForm = () => import('../views/job-application/JobApplicationForm.vue')
const ApplicationSuccessful = () => import('../views/job-application/ApplicationSuccessful')
const ViewJob = () => import('../views/jobs/ViewJob.vue')
const JobsList = () => import('../views/jobs/JobsList.vue')
const WorkflowLayout = () => import('../views/admin/workflows/includes/WorkflowLayout.vue')
const ActiveWorkflowList = () => import('../views/admin/workflows/includes/ActiveWorkflowList.vue')
const InActiveWorkflowList = () => import('../views/admin/workflows/includes/InActiveWorkflowList.vue')
const AllWorkflowList = () => import('../views/admin/workflows/includes/AllWorkflowList.vue')
const AdminCreateNewWorkflow = () => import('../views/admin/workflows/CreateNewWorkflow.vue')
const ForgotPasswordIndex = () => import('../views/forgot-password/Index.vue')
const ResetExpiredPassword = () => import('../components/auth/admin/ResetExpiredPassword.vue')
const AcceptOrDeclineInvite = () => import('../views/admin/jobs/job-management/applicant-tracking-system/job-team/job-team-invite/AcceptOrDeclineInvite.vue')
const AdminJobDetails = () => import('../views/admin/jobs/job-creation/JobDetails.vue')
const AdminJobSettings = () => import('../views/admin/jobs/job-creation/JobSettings.vue')
const AdminApplicationSetup = () => import('../views/admin/jobs/job-creation/ApplicationSetup/ApplicationSetup.vue')
const AdminOverview = () => import('../views/admin/jobs/job-creation/Overview.vue')
const AdminJobList = () => import('../views/admin/jobs/job-management/JobList.vue')
const AdminSetClientPrivacyPolicy = () => import('../views/admin/settings/SetClientPrivacyPolicy.vue')
const ViewClientPrivacyPolicy = () => import('../views/admin/settings/ViewClientPrivacyPolicy.vue')
const AdminPreview = () => import('../views/admin/jobs/job-creation/Preview.vue')
const AdminJobSuccess = () => import('../views/admin/jobs/job-creation/SuccessPage.vue')
const MyApplicationMessage = () => import("../views/my-application/MyApplicationMessage.vue")
const MyApplicationLayout = () => import("../views/my-application/MyApplicationLayout.vue")
const MyApplicationDocument = () => import("../views/my-application/MyApplicationDocument.vue")
const MyApplicationDetails = () => import("../views/my-application/MyApplicationDetails.vue")
const MyApplicationOverview = () => import("../views/my-application/MyApplicationOverview.vue")
const MyLayout = () => import("../views/my-application/MyLayout.vue")
const MyApplication = () => import("../views/my-application/MyApplication.vue")
const MyOverview = () => import("../views/my-application/MyOverview.vue")
const ProfileSettings = () => import('../views/candidate-profile/ProfileSettings.vue')
const AdminSettingsLayout = () => import('../views/admin/settings/includes/Layout.vue')
const AdminCompanySettings = () => import('../views/admin/settings/Company.vue')
const Recruitment = () => import('../views/admin/settings/Recruitment.vue')
const CandidateGDPRConsentPage = () => import('../views/candidate/GDPR/ConsentPage.vue')

// applicant tracking routes
const ATSLayout = () => import('../views/admin/jobs/job-management/applicant-tracking-system/includes/ATSLayout.vue')
const AdminTrackingOverview = () => import('../views/admin/jobs/job-management/applicant-tracking-system/Overview.vue')
const AdminTrackingJobTeam = () => import('../views/admin/jobs/job-management/applicant-tracking-system/job-team/Index.vue')
const AdminTrackingJobPreferences = () => import('../views/admin/jobs/job-management/applicant-tracking-system/Preferences.vue')
const AdminTrackingApplications = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applications/Applications.vue')
const AdminTrackingKanbanApplications = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applications/KanbanApplications.vue')
const AdminDetailedApplicationsView = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applications/ApplicationDetailedView.vue')
const AdminApplicationListView = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applications/ApplicationListView.vue')

//Audit trail
const AuditTrail = () => import('../views/admin/audit-trail/Index.vue')
const WebhookLogs = () => import('../views/admin/logs/WebhooksLogs.vue')
const GDPRLogs = () => import('../views/admin/logs/GDPR/Index.vue')

const AddCandidate = () => import("../views/admin/add-applicant/AddCandidate.vue")

// templates routes
const AdminTemplatesLayout = () => import('../views/admin/templates/includes/TemplatesPageLayout.vue')
const AdminTemplatesCreateOrEditLayout = () => import('../views/admin/templates/includes/CreateOrEditLayout.vue')

// permission routes
const CreateOrEditAdminRole = () => import('../views/admin/templates/permissions/CreateOrEditAdminRole.vue')
const AdminPermissionsJobAdmins = () => import('../views/admin/templates/permissions/ViewJobAdmins.vue')
const AdminPermissionsListing = () => import('../views/admin/templates/permissions/PermissionsListing.vue')

// email templates routes
const AdminEmailTemplatesCreateOrEdit = () => import('../views/admin/templates/Emails/CreateOrEdit.vue')
const AdminEmailTemplateListing = () => import('../views/admin/templates/Emails/EmailTemplateListing.vue')

//interview templates notes
const AdminInterviewNoteTemplatesListing = () => import('../views/admin/templates/interview-notes/InterviewNotesListing.vue')
const AdminInterviewNotesTemplatesCreateOrEdit = () => import('../views/admin/templates/interview-notes/CreateOrEdit.vue')

//Talent Pool routes
const TalentPoolLayout = () => import('../views/admin/jobs/job-management/applicant-tracking-system/talent-pool/TalentPoolLayout.vue')
const AllCandidates = () => import('../views/admin/jobs/job-management/applicant-tracking-system/talent-pool/AllCandidates.vue')
const ManuallyAdded = () => import('../views/admin/jobs/job-management/applicant-tracking-system/talent-pool/ManuallyAdded.vue')
const ExternalSource = () => import('../views/admin/jobs/job-management/applicant-tracking-system/talent-pool/ExternalSource.vue')

//Candidate view routes
const CandidateViewLayout = () => import('../views/admin/jobs/job-management/applicant-tracking-system/candidate-view/CandidateViewLayout.vue')
const CandidateOverview = () => import('../views/admin/jobs/job-management/applicant-tracking-system/candidate-view/Overview.vue')
const CandidateProfile = () => import('../views/admin/jobs/job-management/applicant-tracking-system/candidate-view/CandidateProfile.vue')

const IntegrationSettings = () => import('../views/admin/settings/IntegrationSettings.vue')
const AdminNotificationSettings = () => import('../views/admin/settings/Notifications.vue')
const AdminSubsidiariesSettings = () => import('../views/admin/settings/Subsidiaries.vue')
const ContactInfo = () => import('../views/candidate-profile/includes/ContactInfo.vue')
const Experience = () => import('../views/candidate-profile/includes/Experience.vue')
const AboutYou = () => import('../views/candidate-profile/includes/AboutYou.vue')
const Education = () => import('../views/candidate-profile/includes/Education.vue')
const CandidateSkills = () => import('../views/candidate-profile/includes/CandidateSkills.vue')
const CandidateInterests = () => import('../views/candidate-profile/includes/CandidateInterests.vue')
const ProductNotification = () => import('../views/admin/product-notification/ProductNotification.vue')

// applicant routes
const ApplicantLayout = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantLayout.vue')
const ApplicantOverview = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantOverview.vue')
const ApplicantProfile = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantProfile.vue')
const ApplicantMessages = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantMessages.vue')
const ApplicantDocuments = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantDocuments.vue')
const ApplicantAssessments = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantAssessments.vue')
const AssessmentTests = () => import('../views/admin/jobs/job-management/applicant-tracking-system/assessment-folder/AssessmentTests.vue')
const ApplicantComments = () => import('../views/admin/jobs/job-management/applicant-tracking-system/applicant/ApplicantComments.vue')
const OutlookCallBack = () => import("../views/admin/settings/includes/OutlookCallBack.vue")
const InterviewList = () => import("../views/admin/jobs/job-management/applicant-tracking-system/assessment-folder/InterviewList.vue")

// dashboard routes
const AdminDashboard = () => import('../views/admin/dashboard/AdminDashboard.vue')

// job categorization routes
const JobCategorizationPageLayout = () => import('../views/admin/job-categorization/includes/JobCategorizationPageLayout.vue')
const JobTags = () => import('../views/admin/job-categorization/JobTags.vue')
const JobSpecializations = () => import('../views/admin/job-categorization/JobSpecializations.vue')

// department routes
const Department = () => import('../views/admin/departments/Index.vue')
const ViewSingleDepartment = () => import('../views/admin/departments/ViewSingleDepartment.vue')

//Interviews Routes
const ScheduledInterviews = () => import('../views/admin/jobs/job-management/applicant-tracking-system/interviews/ScheduledInterviews.vue')
const UnscheduledCandidates = () => import('../views/admin/jobs/job-management/applicant-tracking-system/interviews/UnscheduledCandidates.vue')
const ViewApplicantInterviewDetails = () => import('../views/admin/jobs/job-management/applicant-tracking-system/interviews/includes/ViewApplicantInterviewDetails.vue')

// Assessment routes (Overview, Assessments, Batches, Results)
const AssessmentLayout = () => import('../views/admin/assessment/AssessmentLayout.vue')
const AssessmentOverview = () => import('../views/admin/assessment/Overview.vue')
const AssessmentTestList = () => import('../views/admin/assessment/TestList.vue')
const AssessmentTestCreate = () => import('../views/admin/assessment/TestCreate.vue')
const AssessmentTestShow = () => import('../views/admin/assessment/TestShow.vue')
const AssessmentTestEdit = () => import('../views/admin/assessment/TestEdit.vue')
const AssessmentBatchList = () => import('../views/admin/assessment/BatchList.vue')
const AssessmentBatchCreate = () => import('../views/admin/assessment/BatchCreate.vue')
const AssessmentBatchShow = () => import('../views/admin/assessment/BatchShow.vue')
const AssessmentBatchEdit = () => import('../views/admin/assessment/BatchEdit.vue')
const AssessmentBulkAdministerTests = () => import('../views/admin/assessment/BulkAdministerTests.vue')
const AssessmentResultsList = () => import('../views/admin/assessment/ResultsList.vue')
const AssessmentBatchResults = () => import('../views/admin/assessment/BatchResults.vue')
const AssessmentTestResults = () => import('../views/admin/assessment/TestResults.vue')
const AssessmentApplicantResultDetail = () => import('../views/admin/assessment/ApplicantResultDetail.vue')
const AssessmentProctoringSettings = () => import('../views/admin/assessment/ProctoringSettings.vue')

const appRoutes =  {
    jobApplication: [
        {
            path: '/privacy-policy',
            component: ViewClientPrivacyPolicy,
            name: 'View.Client.Privacy.Policy',
        },
        {
            path: '/change-password/:token',
            component: ResetExpiredPassword,
            name: 'Reset.Expired.Password',
        },
        {
            path: '/:userType/forgot-password',
            component: ForgotPasswordIndex,
            name: 'Reset.Password.Link.Email',
        },
        {
            path: '/:userType/reset-password/:token',
            component: ForgotPasswordIndex,
            props: {
                showResetPassword: true
            },
            name: 'Reset.Password',
        },

        {
            path: '/job-team-invite/:id',
            component: AcceptOrDeclineInvite,
            name: 'Job.Team.Invite',
        },

        {
            path: '/jobs',
            component: JobsList,
            name: 'Jobs.Lists',
        },
        {
            path: '/jobs/view/:id',
            component: ViewJob,
            name: 'View.Job',
        },
        {
            path: '/jobs/apply/:id/:section',
            component: JobApplicationForm,
            name: 'Job.Application.Form',
        },
        {
            path: '/jobs/apply/preview-application',
            component: PreviewApplication,
            name: 'Preview.Application',
        },
        {
            path: '/jobs/apply/application-successful',
            component: ApplicationSuccessful,
            name: 'Application.Successful',
        },
        {
            path: "/",
            component: MyLayout,
            name: "MyLayout",
            children: [
                {
                    path: "overview",
                    component: MyOverview,
                    name: "MyOverview",
                },
                {
                    path: "applications",
                    component: MyApplication,
                    name: "MyApplication",
                },
            ]
        },
        {
            path: '/profile-settings',
            beforeEnter(to, from, next) {
                window.location.href = `${window.location.origin}/candidate/advanced#/profile-settings`;
            },
            name: 'ProfileSettings',
        },
        {
            path: '/gdpr-consent/:token',
            component: CandidateGDPRConsentPage,
            name: 'Candidate.GDPR.Consent',
        }
    ],
    applicants: [
        {
            path: '/jobs',
            component: JobsList,
            name: 'Jobs.Lists',
        },
        {
            path: '/jobs/view/:id',
            beforeEnter(to, from, next) {
                window.location.href = `${window.location.origin}/job/view/${to.params.id}`;
            },
            name: 'View.Job',
        },
        {
            path: '/jobs/apply/:id/:section',
            component: JobApplicationForm,
            name: 'Job.Application.Form',
        },
        {
            path: '/jobs/apply/preview-application',
            component: PreviewApplication,
            name: 'Preview.Application',
        },
        {
            path: '/jobs/apply/application-successful',
            component: ApplicationSuccessful,
            name: 'Application.Successful',
        },
        {
            path: "/applications/:id/",
            component: MyApplicationLayout,
            name: "MyApplication.Layout",
            children: [
                {
                    path: "overview",
                    component: MyApplicationOverview,
                    name: "MyApplication.Overview",
                },
                {
                    path: "messages",
                    component: MyApplicationMessage,
                    name: "MyApplication.Message",
                },
                {
                    path: "documents",
                    component: MyApplicationDocument,
                    name: "MyApplication.Document",
                },
                {
                    path: "application-details",
                    component: MyApplicationDetails,
                    name: "MyApplication.Details",
                },

            ]
        },
        {
            path: "/",
            component: MyLayout,
            name: "MyLayout",
            children: [
                {
                    path: "overview",
                    component: MyOverview,
                    name: "MyOverview",
                },
                {
                    path: "applications",
                    component: MyApplication,
                    name: "MyApplication",
                },
            ]
        },
        // Catch all invalid routes and attempt to redirect to /applications if there's auth
        { path: '*', redirect: '/applications' },
        {
            path: "/profile-settings",
            component: ProfileSettings,
            name: "ProfileSettings",
            children: [
                {
                    path: "/contact-info",
                    component: ContactInfo,
                    name: "ContactInfo"
                },
                {
                    path: "/experience",
                    component: Experience,
                    name: "Experience"
                },
                {
                    path: "/about",
                    component: AboutYou,
                    name: "AboutYou"
                },
                {
                    path: "/education",
                    component: Education,
                    name: "Education"
                },
                {
                    path: "/skills",
                    component: CandidateSkills,
                    name: "Skills"
                },
                {
                    path: "/interest",
                    component: CandidateInterests,
                    name: "Interest"
                },
            ]
        }
    ],
    admin: [
        // Catch all invalid routes and attempt to redirect to /dashboard if there's auth
        { path: '*', redirect: '/dashboard' },
        {
            path: '/dashboard',
            component: AdminDashboard,
            name: 'Admin.Dashboard',
        },
        {
            path: '/interview/scheduled-interviews',
            component: ScheduledInterviews,
            name: 'Scheduled.Interviews',
        },
        {
            path: '/interview/unscheduled-candidates',
            component: UnscheduledCandidates,
            name: 'Unscheduled.Candidates',
        },

        {
            path: '/interview/view-details/:id',
            component: ViewApplicantInterviewDetails,
            name: 'Admin.View.Interview.Details',
            // props: {
            //     isEditing: true
            // },
        },

        // Assessment
        {
            path: '/assessment',
            component: AssessmentLayout,
            children: [
                {
                    path: 'overview',
                    component: AssessmentOverview,
                    name: 'Assessment.Overview',
                },
                {
                    path: 'tests',
                    component: AssessmentTestList,
                    name: 'Assessment.Tests.List',
                },
                {
                    path: 'tests/create',
                    component: AssessmentTestCreate,
                    name: 'Assessment.Tests.Create',
                },
                {
                    path: 'tests/:id',
                    component: AssessmentTestShow,
                    name: 'Assessment.Tests.Show',
                },
                {
                    path: 'tests/:id/edit',
                    component: AssessmentTestEdit,
                    name: 'Assessment.Tests.Edit',
                },
                {
                    path: 'batches',
                    component: AssessmentBatchList,
                    name: 'Assessment.Batches.List',
                },
                {
                    path: 'administer',
                    component: AssessmentBulkAdministerTests,
                    name: 'Assessment.BulkAdminister',
                },
                {
                    path: 'batches/create',
                    component: AssessmentBatchCreate,
                    name: 'Assessment.Batches.Create',
                },
                {
                    path: 'batches/:id',
                    component: AssessmentBatchShow,
                    name: 'Assessment.Batches.Show',
                },
                {
                    path: 'batches/:id/edit',
                    component: AssessmentBatchEdit,
                    name: 'Assessment.Batches.Edit',
                },
                {
                    path: 'batches/:id/results',
                    component: AssessmentBatchResults,
                    name: 'Assessment.Batches.Results',
                },
                {
                    path: 'results',
                    component: AssessmentResultsList,
                    name: 'Assessment.Results.List',
                },
                {
                    path: 'results/tests/:id',
                    component: AssessmentTestResults,
                    name: 'Assessment.Results.Test',
                },
                {
                    path: 'results/applicant/:id',
                    component: AssessmentApplicantResultDetail,
                    name: 'Assessment.Results.Applicant',
                },
                {
                    path: 'settings',
                    component: AssessmentProctoringSettings,
                    name: 'Assessment.Settings',
                },
            ],
        },

        {
            path: '/product/notifications',
            component: ProductNotification,
            name: 'Admin.Product.Notification',
        },
        {
            path: '/settings/privacy-policy',
            component: AdminSetClientPrivacyPolicy,
            name: 'Admin.Set.Client.Privacy.Policy',
        },
        {
            path: '/settings',
            component: AdminSettingsLayout,
            name: 'Admin.Settings.Index',
            children: [
                {
                    path: 'company',
                    name: 'Admin.Settings.Company',
                    component: AdminCompanySettings,
                },
                {
                    path: 'recruitment',
                    name: 'Admin.Settings.Recruitment',
                    component: Recruitment,
                },
                {
                    path: 'notifications',
                    name: 'Admin.Settings.Notifications',
                    component: AdminNotificationSettings,
                },
                {
                    path: 'subsidiaries',
                    name: 'Admin.Settings.Subsidiaries',
                    component: AdminSubsidiariesSettings,
                },
                {
                    path: 'permissions',
                    component: AdminPermissionsListing,
                    name: 'Admin.Settings.Permissions'
                }
            ]
        },
        {
            path: 'settings/callback',
            name: 'Admin.Outlook.Callback',
            component: OutlookCallBack,
        },
        {
            path: '/settings/permissions/setup',
            component: AdminTemplatesCreateOrEditLayout,
            name: 'Admin.Settings.Permissions.CreateOrEdit',
            children: [
                {
                    path: 'edit/:type/:roleId',
                    component: CreateOrEditAdminRole,
                    props: {
                        isEditing: true
                    },
                    name: 'Admin.Settings.Permissions.Edit'
                },
                {
                    path: 'create/:type',
                    component: CreateOrEditAdminRole,
                    props: {
                        isEditing: false
                    },
                    name: 'Admin.Settings.Permissions.Create'
                },
                {
                    path: 'job-admins',
                    component: AdminPermissionsJobAdmins,
                    props: {
                        isSuperAdminPage: false
                    },
                    name: 'Admin.Settings.Permissions.View.Job.Admins'
                },
                {
                    path: 'super-admins/:id?',
                    component: AdminPermissionsJobAdmins,
                    props: {
                        isSuperAdminPage: true
                    },
                    name: 'Admin.Settings.Permissions.View.Super.Admins'
                }
            ]
        },

        {
            path: "/templates",
            component: AdminTemplatesLayout,
            name: "Admin.Templates",
            children: [
                {
                    path: 'emails',
                    component: AdminEmailTemplateListing,
                    name: 'Admin.Templates.Emails',
                },
                {
                    path: 'interview-notes',
                    component: AdminInterviewNoteTemplatesListing,
                    name: 'Admin.Templates.InterviewNotes',
                }
            ]
        },
    
    
        {
            path: '/templates/emails',
            component: AdminTemplatesCreateOrEditLayout,
            name: 'Admin.Templates.Email.CreateOrEdit',
            children: [
                {
                    path: 'edit/:templateId',
                    component: AdminEmailTemplatesCreateOrEdit,
                    props: {
                        isEditing: true
                    },
                    name: 'Admin.Templates.Email.Edit'
                },
                {
                    path: 'create',
                    component: AdminEmailTemplatesCreateOrEdit,
                    props: route => ({ isFromJobTeam: route.query.isFromJobTeam, isEditing: false }),
                    name: 'Admin.Templates.Email.Create'
                }
            ]
        },
        {
            path: '/templates/interview-notes',
            component: AdminTemplatesCreateOrEditLayout,
            name: 'Admin.Templates.InterviewNotes.CreateOrEdit',
            children: [
                {
                    path: 'edit/:templateId',
                    component: AdminInterviewNotesTemplatesCreateOrEdit,
                    props: {
                        isEditing: true
                    },
                    name: 'Admin.Templates.InterviewNotes.Edit'
                },
                {
                    path: 'create',
                    component: AdminInterviewNotesTemplatesCreateOrEdit,
                    props: {
                        isEditing: false
                    },
                    name: 'Admin.Templates.InterviewNotes.Create'
                },
            ]
        },
        {
            path: '/workflow',
            component: AdminCreateNewWorkflow,
            name: 'Admin.Create.Workflow',
        },
        {
            path: '/workflow/edit/:id',
            component: AdminCreateNewWorkflow,
            name: 'Admin.Edit.Workflow',
            props: {
                isEditing: true
            },
        },
        {
            path: "/workflows",
            component: WorkflowLayout,
            name: "WorkflowLayout",
            children: [
                {
                    path: 'all',
                    component: AllWorkflowList,
                    name: 'AllWorkflowList',
                },
                {
                    path: "active",
                    component: ActiveWorkflowList,
                    name: "ActiveWorkflowList",
                },
                {
                    path: "inactive",
                    component: InActiveWorkflowList,
                    name: "InActiveWorkflowList",
                }
            ]
        },
        {
            path: "/jobs/:id",
            component: ATSLayout,
            name: "ATSLayout",
            children: [
                {
                    path: 'applications/:step',
                    component: AdminTrackingApplications,
                    name: 'Admin.Applicants.Applications.Step',
                    children: [
                        {
                            path: 'detailed-view/:type',
                            component: AdminDetailedApplicationsView,
                            name: 'Admin.Applicants.DetailedApplicationsView',
                        },
                        {
                            path: 'list-view/:type',
                            component: AdminApplicationListView,
                            name: 'Admin.Applicants.ListViewApplications',
                        },
                        {
                            path: 'kanban-applications/:type',
                            component: AdminTrackingKanbanApplications,
                            name: 'Admin.Applicants.KanbanApplications',
                        },
                    ]
                },
                {
                    path: 'overview',
                    component: AdminTrackingOverview,
                    name: 'Admin.Applicants.Overview',
                },
                {
                    path: 'job-team',
                    component: AdminTrackingJobTeam,
                    name: 'Admin.Applicants.JobTeam',
                },
                {
                    path: 'job-preferences',
                    component: AdminTrackingJobPreferences,
                    name: 'Admin.Applicants.JobPreferences',
                },
            ]
        },
        {
            path: "/:id/add-candidate",
            component: AddCandidate,
            name: "Admin.Add.Candidate",
        },
        {
            path: "/audit-trail",
            component: AuditTrail,
            name: "Admin.Audit.Trail"
        },
        {
            path: "/webhook-logs",
            component: WebhookLogs,
            name: "Admin.Webhook.Logs"
        },
        {
            path: "/gdpr-logs",
            component: GDPRLogs,
            name: "Admin.GDPR.Logs"
        },
        {
            path: "/settings/integrations",
            component: IntegrationSettings,
            name: "Admin.Integrations.Settings"
        },
        {
            path: "/talent-pool",
            component: TalentPoolLayout,
            name: "TalentPoolLayout",
            children: [
                {
                    path: 'all-candidates',
                    component: AllCandidates,
                    name: 'Admin.Applicants.AllCandidates',
                },
                {
                    path: 'manually-added',
                    component: ManuallyAdded,
                    name: 'Admin.Applicants.ManuallyAdded',
                },
                {
                    path: "external-source",
                    component: ExternalSource,
                    name: "Admin.Applicants.ExternalSource",
                }
            ]
        },
        {
            path: "/candidate/:id",
            component: CandidateViewLayout,
            name: "CandidateViewLayout",
            children: [
                {
                    path: 'overview',
                    component: CandidateOverview,
                    name: 'Admin.Applicants.CandidateOverview',
                },
                {
                    path: "candidate-profile",
                    component: CandidateProfile,
                    name: "Admin.Applicants.CandidateProfile",
                }
            ]
        },
        {
            path: '/jobs',
            component: AdminJobList,
            name: 'Admin.Job.List',
        },
        {
            path: '/jobs/:action/job-details/:jobId?',
            component: AdminJobDetails,
            name: 'Admin.Job.Details',
            props: true,
        },
        {
            path: '/jobs/:action/job-settings/:jobId?',
            component: AdminJobSettings,
            name: 'Admin.Job.Settings',
            props: true,
        },
        {
            path: '/jobs/:action/application-setup/:jobId?',
            component: AdminApplicationSetup,
            name: 'Admin.Application.Setup',
            props: true,
        },
        {
            path: '/jobs/:action/overview/:jobId?',
            component: AdminOverview,
            name: 'Admin.Overview',
            props: true,
        },
        {
            path: "/applicants/:id",
            component: ApplicantLayout,
            name: "ApplicantLayout",
            children: [
                {
                    path: 'overview',
                    component: ApplicantOverview,
                    name: 'Applicant.Overview',
                },
                {
                    path: 'profile',
                    component: ApplicantProfile,
                    name: 'Applicant.Profile',
                },
                {
                    path: 'messages',
                    component: ApplicantMessages,
                    name: 'Applicant.Messages',
                },
                {
                    path: 'documents',
                    component: ApplicantDocuments,
                    name: 'Applicant.Documents',
                },
                {
                    path: 'assessments',
                    component: ApplicantAssessments,
                    name: 'Applicant.Assessments',
                    children: [
                        {
                            path: 'interviews',
                            component: InterviewList,
                            name: 'Applicant.Assessments.Interviews',
                        },
                        {
                            path: 'tests',
                            component: AssessmentTests,
                            name: 'Applicant.Assessments.Tests',
                        },
                    ]
                },
                {
                    path: 'comments',
                    component: ApplicantComments,
                    name: 'Applicant.Comments',
                },
            ]
        },
        {

            path: '/jobs/preview',
            component: AdminPreview,
            props: true,
            name: 'Admin.Preview',
            children: [
                {
                    path: 'post/:type/:action/:jobId?',
                    name: 'Admin.Preview.Job.Post',
                    component: ViewJob,
                    props: route => ({ action: route.params.action, jobId: route.params.jobId, isPreviewing: true })
                },
                {
                    path: 'ats-prefrences/preview/:type/:action/:jobId?',
                    name: 'Admin.Preview.Job.ATS',
                    component: ViewJob,
                    props: route => ({ action: route.params.action, jobId: route.params.jobId, isPreviewing: true })
                },
                {
                    path: ':type/:action/:section/:jobId?',
                    name: 'Admin.Preview.Application.Form',
                    component: JobApplicationForm,
                    props: route => ({
                        action: route.params.action,
                        jobId: route.params.jobId,
                        isPreviewing: true
                    })
                },
            ]
        },
        {
            path: "/job-categorization",
            component: JobCategorizationPageLayout,
            name: 'JobCategorization.Page.Layout',
            children: [
                {
                    path: 'tags',
                    component: JobTags,
                    name: 'JobCategorization.Tags',
                },
                {
                    path: 'specializations',
                    component: JobSpecializations,
                    name: 'JobCategorization.Specializations',
                },
            ]
        },
        {
            path: '/jobs/:action/success',
            component: AdminJobSuccess,
            name: 'Admin.Job.Success',
            props: true,
        },
        {
            path: '/department',
            component: Department,
            name: 'Admin.Departments',
        },
        {
            path: '/department/:departmentId',
            component: ViewSingleDepartment,
            name: 'Admin.Department.View'
        }
    ],
    interviewer: [],
}

export default appRoutes;
